import {TELEMEDICINE_URL_UPDATE_FEATURE_BY_HOST} from 'presentation/constants/telemedicineUrlUpdateFeatureByHost';

import {useFeatureFlag} from '../useFeatureFlag';
import {useHostName} from '../useHostName';

export const useTelemedicineUrlUpdateFeature = () => {
	const {
		dataHostNameState: {product},
	} = useHostName();

	return useFeatureFlag(TELEMEDICINE_URL_UPDATE_FEATURE_BY_HOST[product]);
};
